import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APP_CONFIG } from '../config';
import type { AppConfig } from '../config';

@Injectable({ providedIn: 'root' })
export class ApiClientService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<AppConfig>(APP_CONFIG);

  get<TResponse>(path: string, params?: Record<string, string | number | boolean | null | undefined>): Observable<TResponse> {
    const httpParams = toHttpParams(params);

    if (httpParams) {
      return this.httpClient.get<TResponse>(`${this.config.apiBaseUrl}${path}`, {
        params: httpParams,
        withCredentials: true
      });
    }

    return this.httpClient.get<TResponse>(`${this.config.apiBaseUrl}${path}`, {
      withCredentials: true
    });
  }

  post<TResponse>(path: string, body: unknown): Observable<TResponse> {
    return this.httpClient.post<TResponse>(`${this.config.apiBaseUrl}${path}`, body, {
      withCredentials: true
    });
  }

  patch<TResponse>(path: string, body: unknown): Observable<TResponse> {
    return this.httpClient.patch<TResponse>(`${this.config.apiBaseUrl}${path}`, body, {
      withCredentials: true
    });
  }

  delete<TResponse>(path: string): Observable<TResponse> {
    return this.httpClient.delete<TResponse>(`${this.config.apiBaseUrl}${path}`, {
      withCredentials: true
    });
  }

  put<TResponse>(path: string, body: unknown): Observable<TResponse> {
    return this.httpClient.put<TResponse>(`${this.config.apiBaseUrl}${path}`, body, {
      withCredentials: true
    });
  }
}

const toHttpParams = (params?: Record<string, string | number | boolean | null | undefined>): HttpParams | undefined => {
  if (!params) {
    return undefined;
  }

  let httpParams = new HttpParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) {
      continue;
    }

    httpParams = httpParams.set(key, String(value));
  }

  return httpParams;
};
